"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicPurchaseServiceV2 = void 0;
const tslib_1 = require("tslib");
const http_client_1 = require("@wix/http-client");
const api_types_1 = require("@wix/wix-vod-constants/api-types");
const purchase_1 = require("./purchase");
const common_1 = require("@wix/wix-vod-shared/common");
const utils_1 = require("@wix/wix-vod-shared/dist/esm/widget/vod-player/components/share-buttons/utils");
const env_1 = require("@wix/wix-vod-constants/env");
const APIUrls = {
    order: '/cashier/order',
    status: (order, transaction) => `/cashier/order/${order}/transaction/${transaction}/status`,
};
const statusesMap = {
    SUCCESS: api_types_1.PaymentStatus.ACTIVE,
    APPROVED: api_types_1.PaymentStatus.ACTIVE,
    OK: api_types_1.PaymentStatus.ACTIVE,
    PENDING: api_types_1.PaymentStatus.PENDING,
    PENDING_MERCHANT: api_types_1.PaymentStatus.PENDING,
    CANCEL: api_types_1.PaymentStatus.CANCELED,
    CANCELED: api_types_1.PaymentStatus.CANCELED,
};
class PublicPurchaseServiceV2 extends purchase_1.PublicPurchaseService {
    constructor() {
        super(...arguments);
        this.client = new http_client_1.HttpClient({
            baseURL: `${env_1.PRODUCTION_HOSTS.paypal}/vod`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
            xsrfCookieName: null,
            xsrfHeaderName: null,
            params: {
                bsi: (0, utils_1.getBsi)(),
            },
        });
    }
    createOrder(videoId, channelId, paymentType, siteUrl, instance, compId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.client.post(APIUrls.order, {
                channelId,
                refItemId: videoId,
                type: paymentType,
                ref: siteUrl,
                redirectParams: {
                    returnUrl: siteUrl,
                    [common_1.URL_PARAM_COMP_ID]: compId,
                    [common_1.URL_PARAM_VIDEO_ID]: videoId,
                    [common_1.URL_PARAM_PAYMENT_TYPE]: paymentType,
                    [common_1.URL_PARAM_STATE]: common_1.URL_STATE_COMPLETE_PURCHASE,
                },
            }, { params: { instance } });
            return data.order.id;
        });
    }
    getPaymentStatus(videoId, channelId, orderId, transactionId, instance, paymentType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { status } = yield this.client
                .get(APIUrls.status(orderId, transactionId), { params: { instance } })
                .then((response) => ({ status: response.data.status }), (error) => ({ status: 'ERROR', error }));
            return statusesMap[status];
        });
    }
    cancelOrder(channelId, siteUrl, instance) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            (0, common_1.openBlankTab)((0, common_1.buildUrl)(`${env_1.PRODUCTION_HOSTS.paypal}/vod/pp/subscribe/cancel_profile`, {
                type: 'subscription',
                channelId,
                ref: siteUrl,
                instance,
            }));
        });
    }
}
exports.PublicPurchaseServiceV2 = PublicPurchaseServiceV2;
//# sourceMappingURL=purchase.v2.js.map